<template>
  <div @click="setCurrent()" :class="['component-section', (isCurrent ? 'active' : ''), (isDisActive ? 'one-item' : 'set-hover') ]">
    <div class="section-name">
      <span class="hover"></span> 
      {{ data.title }}
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: [
    'title',
    'data',
    'isCurrent',
    'isDisActive',
    'curIndex',
    'index'
  ],

  created () {
    if (this.isCurrent) {
      this.setPage()
    }
  },

  methods: {
    setCurrent () {
      this.$emit('setCurrent', this.index)
    },

    getBackground () {
      let background = this.data.background
      let background_mobile = this.data.background_mobile

      if ($(window).width() < 992 && background_mobile) {
        return background_mobile
      }

      return background 
    },

    setPage () {
      this.$emit('setContent', { 
        html: this.data.body, 
        image: null,
        background: this.getBackground(),
        color: null,
        link: null
      })
    },

    next() {
      return false
    },

    prev() {
      return false
    }
  },

  watch: {
    isCurrent (val) {
      this.isCurrent = val
        //    let dir = this.isCurrent > val ? 'next' : 'prev'
      if (this.isCurrent) {
        this.setPage()
      }
    }
  }
}
</script>

<style lang="scss">
.promo {
  .sections {
    .component-section {
      color: #F2F2F2;
      height: 100%;
      font-size: 16px;
      padding: 30px 10px 30px 20px;
      cursor: pointer;
      display: flex;
      align-items: flex-end;
      font-weight: 100;
      &.one-item {
        cursor: auto;
      }
      // &.set-hover:hover {
      //   background-color: rgba(86, 204, 242, 0.35) !important;
      // }
      .section-name {
        display: flex;
        align-items: center;
        .hover {
          transition: all .5s ease;
          width: 0px;
          height: 1px;
          background-color: #F2F2F2;
          margin-right: 10px;
        }
      }

      &:hover, &.active {
        .section-name {
          .hover {
            width: 15px;
          }
        }
      }
    }
  }
}
</style>